
export default {
    name: "Accounts",
    data() {
        return {
            currentRole: {
                Name: "",
                Description: "",
                Enable: true,
                Function: [],
            },
            currentAccount: {
                UserName: "",
                Name: "",
                Password: "",
                Description: "",
                RoleID: "",
                Enable: true,
                Email: ''
            },
            mlRoleTitle: "",
            mlAccountTitle: "",
            roles: [],
            accounts: [],
            keyword: ''
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            this.roles = await this.$api.getRoles();
            var cols = [
                { title: "群組名稱", data: "Name" },
                { title: "說明", data: "Description" },
                {
                    title: "狀態",
                    data: "Enable",
                    className: 'tac',
                    render: function (data) {
                        if (data) {
                            return '<div class="status-label enabled">啟用</div>';
                        }
                        return '<div class="status-label disabled">停用</div>';
                    },
                },
                {
                    title: "功能",
                    data: "Id",
                    className: 'tac',
                    render: function (data) {
                        return `<div class="btn btn-md btn-primary btn-edit-no-text mg-right-8" onclick="window.model.editRole(${data})"></div>` +
                            (data > 5
                                ? `<div class="btn btn-md btn-default btn-remove-no-text" onclick="window.model.delAccount(${data})"></div>` : "");
                    }
                },
            ];

            this.createDataTable("#tabRoles", cols, this.roles, { 
                bSort: false, searching: false, paging: false, bInfo :false });

            this.accounts = await this.$api.getAccounts();
            cols = [
                { title: "帳號", data: "UserName" },
                { title: "姓名", data: "Name" },
                { title: "所屬群組", data: "RoleName" },
                {
                    title: "狀態",
                    data: "Enable",
                    className: 'tac',
                    render: function (data) {
                        if (data) {
                            return '<div class="status-label enabled">啟用</div>';
                        }
                        return '<div class="status-label disabled">停用</div>';
                    },
                },
                {
                    title: "功能",
                    data: "Id",
                    className: 'tac',
                    render: function (data) {
                        return `<div class="btn btn-md btn-primary btn-edit-no-text mg-right-8" onclick="window.model.editAccount(${data})"></div>
                        <div class="btn btn-md btn-default btn-remove-no-text" onclick="window.model.delAccount(${data})"></div>`;
                    },
                },
            ];
            this.createDataTable("#tabAccounts", cols, this.accounts, { 
                bSort: false, paging: false, bInfo :false });
            setTimeout(() => {
                $('div.dataTables_wrapper div.dataTables_filter').hide();
            });
        },
        showAdd() {
            var bv = $(".tab-menu li:first").hasClass("active");
            if (bv) {
                this.mlRoleTitle = "新增群組";
                this.currentRole = {
                    Name: "",
                    Description: "",
                    Enable: true,
                    Function: [],
                };
                this.$bvModal.show("mlRole");
            } else {
                this.mlAccountTitle = "新增帳號";
                this.currentAccount = {
                    UserName: "",
                    Name: "",
                    Password: "",
                    Description: "",
                    RoleID: "",
                    Enable: true,
                    Email: ''
                };
                this.$bvModal.show("mlAccount");
            }
        },
        editRole(id) {
            this.mlRoleTitle = "修改群組";
            $.each(this.roles, (i, r) => {
                if (r.Id == id) {
                    this.currentRole = r;
                }
            });
            this.currentRole.Function = this.currentRole.Function || [];
            this.$bvModal.show("mlRole");
        },
        async delRole(id) {
            $.each(this.roles, (i, r) => {
                if (r.Id == id) {
                    this.currentRole = r;
                }
            });
            if (this.currentRole) {
                this.confirm("請問要刪除群組：" + this.currentRole.Name, async (r) => {
                    await this.$api.deleteRole(this.currentRole.Id);
                    this.load();
                });
            }
        },
        async mlRoleOK(e) {
            e.preventDefault();
            if (!this.currentRole.Name) {
                alert("所有欄位皆為必填");
                return;
            }

            try {
                if (this.currentRole.Id) {
                    await this.$api.updateRole(this.currentRole);
                } else {
                    await this.$api.createRole(this.currentRole);
                }
                this.$bvModal.hide("mlRole");
                this.load();
            } catch (ex) {
                console.log(ex);
            }
            return;
        },
        editAccount(id) {
            this.mlAccountTitle = "修改帳號";
            $.each(this.accounts, (i, r) => {
                if (r.Id == id) {
                    this.currentAccount = r;
                }
            });
            this.$bvModal.show("mlAccount");
        },
        async delAccount(id) {
            $.each(this.accounts, (i, r) => {
                if (r.Id == id) {
                    this.currentAccount = r;
                }
            });
            if (this.currentAccount) {
                this.confirm("請問要刪除帳號：" + this.currentAccount.Name, async (r) => {
                    await this.$api.deleteAccount(this.currentAccount.Id);
                    this.load();
                });
            }
        },
        async mlAccountOK(e) {
            e.preventDefault();
            if (!this.currentAccount.Name || !this.currentAccount.RoleID) {
                alert("所有欄位皆為必填");
                return;
            }
            try {
                if (this.currentAccount.Id) {
                    await this.$api.updateAccount(this.currentAccount);
                } else {
                    await this.$api.createAccount(this.currentAccount);
                }
                this.$bvModal.hide("mlAccount");
                this.load();
            } catch (ex) {
                console.log(ex);
                if (ex.Status == 4) {
                    alert("此帳號已存在");
                }
            }
            return;
        },
        rbRoleAllChanged(e) {
            var t = $(e.target);
            var p = t.parent().parent();
            $(".lv2 input", p).prop("checked", t.prop("checked"));
            $.each($(".lv2 input", p), (i, e) => {
                e.dispatchEvent(new Event("change"));
            });
        },
        search(){
            $('div.dataTables_wrapper div.dataTables_filter input').val(this.keyword);
            $('div.dataTables_wrapper div.dataTables_filter input').trigger('paste');
        }
    },
};